import split from 'lodash/split';
import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { isSetContextEnabled } from '../../contactUs/actions/action-article';

const ARTICLE_URL = '/smarthelp/article-content';

function requestArticle() {
  return { type: types.REQUEST_MACHINE_ARTICLE };
}

function receiveArticle(responseData) {
  return {
    type: types.RECEIVE_MACHINE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveArticleError() {
  return { type: types.RECEIVE_MACHINE_ARTICLE_ERROR };
}

export default function fetchMachineArticle({ faqId, locale }) {
  return (dispatch, getState) => {
    dispatch(requestArticle());
    const faq = split(faqId, ',')[0];
    let articleURL = `${ARTICLE_URL}?article_id=${faq}`;

    const topicRefId = _get(getState(), 'selectResult.topicTreeSelectResult.topicRefId', null);

    if (locale) {
      articleURL = Page.setURLQuery(articleURL, 'locale', locale);
    }

    return axios.get(articleURL)
      .then((response) => {
        if (response.data && response.data.articleContent) {
          dispatch(receiveArticle(response.data.articleContent));

          // Set context Validations and API call
          isSetContextEnabled(response.data, topicRefId, faqId);
        }
      })
      .catch(() => {
        dispatch(receiveArticleError());
      });
  };
}
